import { Toaster as SonnerToaster } from "sonner";

interface ToasterProps {
  position?:
    | "top-left"
    | "top-right"
    | "bottom-left"
    | "bottom-right"
    | "top-center"
    | "bottom-center";
  richColors?: boolean;
  closeButton?: boolean;
  duration?: number;
  theme?: "light" | "dark" | "system";
}

export function Toaster({
  position = "top-right",
  richColors = true,
  closeButton = true,
  duration = 3000,
  theme = "system",
  ...props
}: ToasterProps) {
  return (
    <SonnerToaster
      position={position}
      richColors={richColors}
      closeButton={closeButton}
      duration={duration}
      theme={theme}
      className="sonner-toast-container"
      toastOptions={{
        className: "sonner-toast",
        descriptionClassName: "sonner-toast-description",
      }}
      {...props}
    />
  );
}
